import React, { Component } from 'react';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import ActionHelpOutline from '@mui/icons-material/HelpOutline';
import NavigationCancel from '@mui/icons-material/Cancel';

export default class HilfeAdornment extends React.Component {

  adornment = () => {
    return(
      <InputAdornment position="end">
        <IconButton sx={{ '& .MuiSvgIcon-root': { fontSize: 28 }}}
          aria-label="Toggle password visibility"
          onClick={this.props.hilfeUmschalten}
        >
          {this.props.hilfeAktiv ? <NavigationCancel /> : <ActionHelpOutline />}
        </IconButton>
      </InputAdornment>
    )
  }

  render () {
    if (this.props.hilfe) {
      return this.adornment()
    }
    return null
  }

}
